





















































helpers = require '../../helpers.coffee'

view_model = {
  props: ['action']

  data: ->
    qualification_statistics: @action.recipients_statistics?.by_qualification
    row_hovered: false

  computed:
    preview_id: ->
      "preview_#{@action.id}"

    data_target_id: ->
      "##{@preview_id}"

    cursor: ->
      if @has_template then 'pointer' else ''

    has_template: ->
      @action.template_id?

    label_by_template_kind: ->
      switch @action.template?.kind
        when 'linkedin', 'phonecall', 'social'
          this.$t('flows.attributes.name')
        when 'email'
          this.$t('flows.attributes.subject')
        else
          ''

    value_by_template_kind: ->
      switch @action.template?.kind
        when 'linkedin', 'phonecall', 'social'
          @action.template.name
        when 'email'
          @action.template.subject
        else
          ''

    recipients_statistics_conversion: ->
      return '--' unless @action.recipients_statistics.by_qualification
      percentage = (@action.recipients_statistics.by_qualification.conversion.value * 100.0).toFixed(1)
      percentage.replace('.', ',') + '%'

    action_legend: ->
      text = this.$t('flows.label.stepLabel', { step: @action.human_step })
      text += ' - '

      if @action.immediately
        stepImmediately = this.$t('flows.label.stepImmediately')
        text += stepImmediately
      else if !@action.delay_after_previous_step_unit
        if @action.undefined_time
          stepUndefinedTime = this.$t('flows.label.stepUndefinedTime')
          text += stepUndefinedTime
        else
          stepDefinedTime = this.$t('flows.label.stepDefinedTime', { time: @action.humanSendAt() })
          text += stepDefinedTime
      else
        if @action.is_first
          stepAfterFlow = this.$t('flows.label.stepAfterFlow', { time: @action.humanDelay() })
          text += stepAfterFlow
        else
          stepAfterStep = this.$t('flows.label.stepAfterStep', { time: @action.humanDelay(), step: (@action.human_step - 1) })
          text += stepAfterStep
        if !@action.undefined_time
          atLabel = this.$t('general.label.at', { time: @action.humanSendAt() })
          text += " " + atLabel
      text

    conversion: ->
      @qualification_statistics.connected.count + @qualification_statistics.client.count

    show_conversion_statistic: ->
      return false if !@qualification_statistics
      return true if @action.isEmailFlowAction() && @action.email_statistic
      true

    total_for_conversion: ->
      if @action.isEmailFlowAction() then @action.email_statistic.sent else @action.recipients_statistics.total.count

  mounted: ->
    document.querySelectorAll(".list-item .preview a").forEach (item) ->
      item.setAttribute("target", "_blank")
}

exports.default = helpers.vue_include view_model, helpers.form




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flow_actions/list_item.vue